import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/c4elogo-new.svg'


const _withScopeId = n => (_pushScopeId("data-v-0bc5d45d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tier_container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tier_container__top" }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"300px","height":"100px"},
    src: _imports_0,
    alt: "c4e logo"
  })
], -1 /* HOISTED */))
const _hoisted_3 = { class: "tier_container__middle" }
const _hoisted_4 = { style: {"font-weight":"bold"} }
const _hoisted_5 = { class: "list" }
const _hoisted_6 = { class: "tier_container__bottom" }
const _hoisted_7 = {
  key: 1,
  style: {"font-weight":"bold","color":"#72bf44","font-size":"1.2rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h2", _hoisted_4, _toDisplayString($props.header), 1 /* TEXT */),
      _createElementVNode("div", null, _toDisplayString($props.description), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.listOfSteps, (step) => {
          return (_openBlock(), _createElementBlock("div", {
            key: step,
            style: {"margin-top":"15px","padding":"5px","border-bottom":"1px solid rgba(143,143,143,0.2)"}
          }, [
            (step.state == $setup.KycProgressStatus.APPROVED)
              ? (_openBlock(), _createBlock($setup["Icon"], {
                  key: 0,
                  style: {"color":"#72bf44","width":"35px","height":"35px"},
                  name: "Check"
                }))
              : (step.state == $setup.KycProgressStatus.REJECTED)
                ? (_openBlock(), _createBlock($setup["Icon"], {
                    key: 1,
                    style: {"color":"#ff2500","width":"35px","height":"35px"},
                    name: "X"
                  }))
                : (step.state == $setup.KycProgressStatus.PENDING_VERIFICATION)
                  ? (_openBlock(), _createBlock($setup["Icon"], {
                      key: 2,
                      style: {"color":"#002C50","width":"35px","height":"35px"},
                      name: "RotateCw"
                    }))
                  : (_openBlock(), _createBlock($setup["Icon"], {
                      key: 3,
                      style: {"color":"#ff2500","width":"35px","height":"35px"},
                      name: "X"
                    })),
            _createTextVNode(" " + _toDisplayString($setup.getStepName(step.name)), 1 /* TEXT */)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (!$setup.isVerified())
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            onClick: $setup.onVerifyClick
          }, {
            default: _withCtx(() => [
              _createTextVNode("Verify with Synaps")
            ]),
            _: 1 /* STABLE */
          }))
        : (_openBlock(), _createElementBlock("span", _hoisted_7, [
            _createVNode($setup["Icon"], {
              style: {"color":"#72bf44","width":"35px","height":"35px"},
              name: "Check"
            }),
            _createTextVNode(" Verified ")
          ]))
    ])
  ]))
}